import format from "date-fns/format";
import { useMemo } from "react";
import { useSelector } from "react-redux";

import { TimeStamp } from "@/models/timestamp";
import { RootState } from "@/reducers/types";
import { Timestamp } from "@/sx-layout/models";

export const useTimestamp = (timestamp?: Timestamp | TimeStamp) => {
  const companies = useSelector((state: RootState) => state.layoutApp.layoutMasters.companies);
  const users = useSelector((state: RootState) => state.layoutApp.layoutMasters.users);

  // 登録日
  const formattedInsertDate = useMemo(() => {
    if (!timestamp?.insert_date) return "";
    return format(new Date(timestamp.insert_date), "yyyy/MM/dd");
  }, [timestamp?.insert_date]);

  // 登録日時
  const formattedInsertDatetime = useMemo(() => {
    if (!timestamp?.insert_date) return "";
    return format(new Date(timestamp.insert_date), "yyyy/MM/dd HH:mm");
  }, [timestamp?.insert_date]);

  const insertUserNameWithCompanyName = useMemo(() => {
    if (!timestamp?.insert_user_id) return "";
    const user = users.find((user) => user.user_id === Number(timestamp.insert_user_id));
    const company = companies.find((company) => company.company_id === Number(user?.company_id));

    return `${user?.user_name}${company?.company_name ? `（${company.company_name}）` : ""}`;
  }, [timestamp?.insert_user_id, companies, users]);

  return { formattedInsertDate, formattedInsertDatetime, insertUserNameWithCompanyName };
};
